import { createSlice } from '@reduxjs/toolkit';

const uiSlice = createSlice({
    initialState: {
        showToast: {
            title: '',
            text: '',
            type: '',
        },
        sidebarShow: 'responsive',
    },
    name: 'UI',
    reducers: {
        toggleSidebarAction: (state, action) => {
            state.sidebarShow = action.payload.sidebarShow;
        },
        showToastAction: (state, action) => {
            // Callers use either `text` or `message` for the body. The toast
            // component only reads `text`, so normalize here — otherwise a
            // `message`-only payload renders nothing and the user sees the
            // action silently do nothing (e.g. email campaign send errors).
            const payload = action.payload || {};
            state.showToast = {
                ...payload,
                text: payload.text || payload.message || '',
                title: payload.title || payload.type,
            };
        },
        clearToastAction: state => {
            state.showToast = {
                title: '',
                text: '',
                type: '',
            };
        },
    },
});

export const { toggleSidebarAction, showToastAction, clearToastAction } =
    uiSlice.actions;

export default uiSlice.reducer;
